function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MARKER_ID = 'SEARCH_RESULT_MARKER';
var RESULTS_LAYER_ID = 'SEARCH_RESULT_LAYER';
var INFOBOX_ID = 'SEARCH_RESULT_INFOBOX';
var getMsg = function getMsg(key) {
  return Oskari.getMsg('MapModule', key);
};
export var SearchResultHelper = /*#__PURE__*/function () {
  function SearchResultHelper(sandbox) {
    var useInfobox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    _classCallCheck(this, SearchResultHelper);
    this.sandbox = sandbox;
    this.useInfobox = !!useInfobox;
    this.resultActions = {};
  }
  return _createClass(SearchResultHelper, [{
    key: "getSandbox",
    value: function getSandbox() {
      return this.sandbox;
    }
  }, {
    key: "addSearchResultAction",
    value: function addSearchResultAction(action) {
      this.resultActions[action.name] = action.callback;
    }
  }, {
    key: "removeSearchResultAction",
    value: function removeSearchResultAction(name) {
      delete this.resultActions[name];
    }
  }, {
    key: "setMarker",
    value: function setMarker(result) {
      if (this.useInfobox) {
        this.showInfobox(result);
        return;
      }
      var lat = typeof result.lat !== 'number' ? parseFloat(result.lat) : result.lat;
      var lon = typeof result.lon !== 'number' ? parseFloat(result.lon) : result.lon;
      this.getSandbox().postRequestByName('MapModulePlugin.AddMarkerRequest', [{
        color: 'ffde00',
        msg: result.name,
        shape: 2,
        size: 3,
        x: lon,
        y: lat
      }, MARKER_ID]);
    }
  }, {
    key: "removeMarker",
    value: function removeMarker() {
      this.getSandbox().postRequestByName('MapModulePlugin.RemoveMarkersRequest', [MARKER_ID]);
    }
  }, {
    key: "showResultOnMap",
    value: function showResultOnMap(result) {
      this.getSandbox().postRequestByName('MapModulePlugin.AddFeaturesToMapRequest', [result.GEOMETRY, {
        layerId: RESULTS_LAYER_ID,
        attributes: _objectSpread(_objectSpread({}, result), {}, {
          id: result.id
        })
      }]);
      this.getSandbox().postRequestByName('MapModulePlugin.ZoomToFeaturesRequest', [{
        layer: [RESULTS_LAYER_ID],
        // don't zoom too close for point features
        maxZoomLevel: 10
      }]);
    }
  }, {
    key: "removeResultFromMap",
    value: function removeResultFromMap(result) {
      var params = [];
      if (result) {
        // clear based on id
        // TODO: not all features have ids (only ones from wfs-search channel does)
        // assuming the searchhandler generated an id for results that don't have one
        params.push('id');
        params.push(result.id);
      } else {
        // clear all
        params.push(null);
        params.push(null);
      }
      params.push(RESULTS_LAYER_ID);
      this.getSandbox().postRequestByName('MapModulePlugin.RemoveFeaturesFromMapRequest', params);
    }
  }, {
    key: "showInfobox",
    value: function showInfobox(result) {
      var _this = this;
      var lat = typeof result.lat !== 'number' ? parseFloat(result.lat) : result.lat;
      var lon = typeof result.lon !== 'number' ? parseFloat(result.lon) : result.lon;
      var resultActions = Object.keys(this.resultActions).map(function (name) {
        var actionFn = _this.resultActions[name];
        return {
          name: name,
          type: 'link',
          action: actionFn(result),
          group: 1
        };
      });
      var sandbox = this.getSandbox();
      var closeAction = {
        name: getMsg('plugin.SearchPlugin.resultBox.close'),
        type: 'link',
        group: 1,
        action: function action() {
          return sandbox.postRequestByName('InfoBox.HideInfoBoxRequest', [INFOBOX_ID]);
        }
      };
      resultActions.push(closeAction);
      var alternatives = createAlternativeNamesHTMLBlock(result);
      var contentItem = {
        html: "<h3>".concat(Oskari.util.sanitize(result.name), "</h3>\n                    ").concat(alternatives, "\n                    <p>").concat(result.region, "<br/>\n                    ").concat(result.type, "</p>"),
        actions: resultActions
      };
      var content = [contentItem];
      var options = {
        hidePrevious: true
      };
      sandbox.postRequestByName('InfoBox.ShowInfoBoxRequest', [INFOBOX_ID, getMsg('plugin.SearchPlugin.resultBox.title'), content, {
        lon: lon,
        lat: lat
      }, options]);
    }
  }]);
}();
var createAlternativeNamesHTMLBlock = function createAlternativeNamesHTMLBlock(result) {
  if (!result || !result.localized) {
    return '';
  }
  var alternatives = result.localized.filter(function (cur) {
    return cur.name !== result.name;
  }).map(function (cur) {
    return "".concat(cur.name, " [").concat(cur.locale, "]");
  }).sort();
  if (alternatives.length === 0) {
    return '';
  }
  var div = document.createElement('div');
  div.style.fontSize = '12px';
  var list = document.createElement('ul');
  alternatives.forEach(function (txt) {
    var item = document.createElement('li');
    item.append(document.createTextNode(txt));
    list.append(item);
  });
  list.style.marginTop = '5px';
  list.style.listStylePosition = 'inside';
  div.append(document.createTextNode(getMsg('plugin.SearchPlugin.resultBox.alternatives')));
  div.append(list);
  return div.outerHTML;
};